import { createSelector } from 'reselect';
import _ from 'lodash';
import moment from 'moment';
import Cookies from 'js-cookie';

const ATTRS_LABEL = {
  name: '姓名',
  gender: '性别',
  tel: '电话',
  email: '邮箱',
  qq: 'QQ',
  weixin: '微信',
  weibo: '微博',
  address: '地址',
  comment: '备注',
  age: '年龄',
  tag: '顾客标签',
  created_on: '创建顾客时间',
  updated_on: '更新时间',
  latest_conv_on: '最近一次对话时间',
  latest_visit_on: '最近一次访问时间',
  contact: '联系人'
};

export const getConvData = createSelector([convData => convData], convData => {
  const sortedConvData = _.sortBy(convData, ['ended_on']);
  const startIndex = 0;
  const lastIndex = convData.length - 1;
  return sortedConvData.map((val, index) => {
    const { after_conv, before_conv } = val;
    if (!after_conv && !before_conv) {
      return val;
    }
    const afterConvId = _.get(after_conv, 'id', '');
    const beforeConvId = _.get(before_conv, 'id', '');
    let hasLoadBefore = !!beforeConvId;
    let hasLoadAfter = !!afterConvId;

    if (index !== startIndex) {
      const beforeConv = sortedConvData[index - 1];
      if (beforeConv.convId === beforeConvId) {
        hasLoadBefore = false;
      }
    }
    if (index !== lastIndex) {
      const afterConv = sortedConvData[index + 1];
      if (afterConv.convId === afterConvId) {
        hasLoadAfter = false;
      }
    }
    return Object.assign({}, val, {
      hasLoadBefore,
      hasLoadAfter
    });
  });
});

/*
 * streams处理
 * */

const getAgentNameById = (list, id) => {
  const agent = list.find(val => val.id === id);
  return (agent && (agent.realname || agent.nickname)) || '';
};

const addExtraInStream = (stream, agents) => {
  const { extra } = stream;
  let extraProps = {};
  if (extra && extra.anonymous_assistance_actual_agent_id) {
    const agentName = getAgentNameById(agents, extra.anonymous_assistance_actual_agent_id);
    extraProps = { agentName };
  }

  return { ...stream, ...extraProps };
};

const NORMAL_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const getEvent = (stream, tags, customerField) => {
  const { action, body } = stream;
  if (action === 'update_conv_tag') {
    const { added_tag_ids, deleted_tag_ids } = body;
    let added_tag = [];
    let deleted_tag = [];
    if (added_tag_ids && added_tag_ids.length) {
      added_tag_ids.forEach(id => {
        const convTag = tags.find(tag => tag.id === id);
        if (convTag) {
          added_tag = [...added_tag, convTag];
        }
      });
    }
    if (deleted_tag_ids && deleted_tag_ids.length) {
      deleted_tag_ids.forEach(id => {
        const convTag = tags.find(tag => tag.id === id);
        if (convTag) {
          deleted_tag = [...deleted_tag, convTag];
        }
      });
    }
    return {
      ...stream,
      action,
      body: {
        ...body,
        added_tag,
        deleted_tag
      }
    };
  }
  if (['agent_change_attr', 'client_reply_card'].includes(action)) {
    const { attrs, old_attrs } = body;
    const oldAttrs = {};
    const newAttrs = Object.keys(attrs).reduce((prev, now) => {
      let attrValue = attrs[now];
      let oldAttrValue = null;
      if (old_attrs) {
        oldAttrValue = old_attrs[now] || null;
      }
      let attrLabel = ATTRS_LABEL[now] || now;
      const field = customerField.find(val => val.name === now);
      if (!field) {
        if (old_attrs) {
          oldAttrs[attrLabel] = oldAttrValue;
        }
        return {
          ...prev,
          [attrLabel]: attrValue
        };
      } else {
        // * 单独处理自定义字段
        if (field.category === 'custom') {
          attrLabel = field.display_name || field.name || field.label || now;
        }
      }
      const { metainfo, type: fieldType } = field;
      switch (fieldType) {
        case 'string':
        case 'number':
          break;
        case 'radio':
          const metaItem = metainfo.find(val => val.value === attrValue);
          if (metaItem) {
            attrValue = metaItem.name;
          }
          if (oldAttrValue) {
            const oldMetaItem = metainfo.find(val => val.value === oldAttrValue);
            if (metaItem) {
              oldAttrValue = oldMetaItem.name;
            }
          }
          break;
        case 'date':
        case 'datetime':
          attrValue = moment
            .utc(attrValue)
            .local()
            .format(NORMAL_FORMAT);
          if (oldAttrValue) {
            oldAttrValue = moment
              .utc(oldAttrValue)
              .local()
              .format(NORMAL_FORMAT);
          }
          break;
        case 'check':
        case 'checkbox':
          if (attrValue) {
            attrValue = attrValue.join(',');
          }
          if (oldAttrValue) {
            oldAttrValue = oldAttrValue.join(',');
          }
          break;
        default:
          break;
      }
      oldAttrs[attrLabel] = oldAttrValue;
      prev = {
        ...prev,
        [attrLabel]: attrValue
      };
      return prev;
    }, {});

    return {
      ...stream,
      action,
      body: {
        ...body,
        attrs: newAttrs,
        old_attrs: oldAttrs
      }
    };
  }

  return stream;
};
const isSelfMessage = stream => {
  const agentId = Cookies.get('_agent_id');
  const anonId = stream.extra ? stream.extra.anonymous_assistance_actual_agent_id : 0;
  const normal = +agentId === +stream.agent_id;
  const anonymous = +agentId === +anonId;
  return anonId ? anonymous : normal;
};

const addTranslateData = (stream, translateData) => {
  if (translateData[stream.id]) {
    stream.translate = translateData[stream.id];
  }
  return { ...stream };
};

const addSpeechData = (stream, speechData) => {
  if (speechData[stream.id]) {
    stream.speechToTxt = speechData[stream.id];
  }
  return { ...stream };
};

export const getStreams = (streams, agents, chatTags, customerField, currentTranslateData, currentSpeechData) => {
  let newStreams = [...streams];
  const contentMap = {};
  // 后端数据结构与预期不符  导致白屏(当修改名片值过长，streams中的body为null)
  // 暂用try catch  并且筛掉不符合要求的数据
  newStreams = newStreams
    .map(stream => {
      let newStream = stream;
      try {
        // 添加匿名消息的客服名称
        newStream = addExtraInStream(stream, agents);
        // 修改对话标签  顾客名片事件
        newStream = getEvent(newStream, chatTags, customerField);

        newStream = addTranslateData(newStream, currentTranslateData);
        // 语音转文字
        if (stream.content_type === 'audio') {
          newStream = addSpeechData(newStream, currentSpeechData);
        }
        // 记录普通文本消息，用于撤回重新编辑
        if (stream.content_type === 'text' && stream._currentChat) {
          //有消息卡片则不记录
          if (!stream?.extra?.operator_msg?.length) {
            contentMap[stream.id] = stream.content;
          }
        }
      } catch (e) {
        return null;
      }

      return {
        ...newStream,
        selfMessage: isSelfMessage(stream)
      };
    })
    .filter(val => val);
  // 撤回重新编辑添加原始文本消息
  newStreams.forEach(s => {
    if (s.action === 'withdraw_msg') {
      s.body.msg_content = contentMap[s.body.msg_id];
    }
  });

  return _.sortBy(newStreams, val => {
    const getCreateOn = val => {
      switch (val.action) {
        case 'withdraw_msg':
        case 'client_withdraw_msg':
          // 撤回消息，排序使用消息的时间
          return (val.body && val.body.msg_created_time) || val.created_on;
        case 'fail_message':
          // 当前时间减去八个小时
          return moment(val.created_on).subtract(8, 'hours');
        default:
          return val.created_on;
      }
    };

    const time = getCreateOn(val);
    return moment(time).valueOf();
  });
};

/*
 * 1.组合【对话小结】
 * 2.处理streams
 * */
export const combineConvData = createSelector(
  [
    convData => convData,
    (convData, summary) => summary,
    (convData, summary, agent) => agent,
    (convData, summary, agent, settingTag) => settingTag,
    (convData, summary, agent, settingTag, customerField) => customerField,
    (convData, summary, agent, settingTag, customerField, convTag) => convTag,
    (convData, summary, agent, settingTag, customerField, convTag, currentTranslateData) => currentTranslateData,
    (convData, summary, agent, settingTag, customerField, convTag, currentTranslateData, currentSpeechData) =>
      currentSpeechData
  ],
  (convData, summary, agentList, settingTag, customerField, convTag, currentTranslateData, currentSpeechData) => {
    return convData.map(conv => {
      const { convId, streams } = conv;
      let newStreams = [];
      if (streams) {
        newStreams = getStreams(streams, agentList, settingTag, customerField, currentTranslateData, currentSpeechData);
      }
      let centerConv = {};
      if (summary && summary[convId]) {
        centerConv = Object.assign({}, centerConv, {
          ...summary[convId]
        });
      }

      if (convTag && convTag[convId]) {
        centerConv = Object.assign({}, centerConv, {
          convTags: convTag[convId] || []
        });
      }
      return Object.assign({}, conv, {
        streams: newStreams,
        centerConv
      });
    });
  }
);

// 添加中间状态
export const addConvStatus = createSelector(
  [requestingConv => requestingConv, (requestingConv, data) => data],
  (requestingConv, data) => {
    return data.map(val => {
      const { before_conv, after_conv } = val;
      let extra = {};
      if (before_conv && requestingConv[before_conv.id]) {
        extra = {
          ...extra,
          before_conv: {
            ...before_conv,
            waiting: true
          }
        };
      }
      if (after_conv && requestingConv[after_conv.id]) {
        extra = {
          ...extra,
          after_conv: {
            ...after_conv,
            waiting: true
          }
        };
      }

      return {
        ...val,
        ...extra
      };
    });
  }
);

// 添加引用消息到消息体当中
export const addRemindMessage = createSelector([convData => convData], convData => {
  return convData.map(val => {
    const { streams } = val;
    return Object.assign({}, val, {
      streams: streams.map(stream => {
        const action = _.get(stream, 'action', '');
        const remindMessageId = _.get(stream, 'extra.reply_msg_id', '');
        const failMessageId = _.get(stream, 'body.msg_id', '');
        // 标记这个事件，标记的消息是发送失败状态
        if (failMessageId && action === 'send_message_fail') {
          const failMessage = streams.find(val => val.id === failMessageId);
          if (failMessage) {
            failMessage.fail = true;
          }
        }
        if (remindMessageId) {
          const activeItem = streams.find(val => val.id === remindMessageId);
          if (activeItem) {
            return {
              ...stream,
              customExtra: {
                ...stream.customExtra,
                remindMessage: activeItem
              }
            };
          }
        }
        return stream;
      })
    });
  });
});

export const getAllStreams = createSelector([convData => convData], convData => {
  if (convData && convData.length > 0) {
    return convData.reduce((prev, now) => {
      const { streams } = now;
      return [...prev, ...streams];
    }, []);
  }
  return [];
});
